import React from "react";
import "./AboutSpotlight.css";

function AboutSpotlight() {
  return (
    <div className="aboutspotlight">
      <div className="content">
        <h3>We are passionate about revolutionizing</h3>
        <p>the way businesses operate through the power of technology</p>
      </div>
    </div>
  );
}

export default AboutSpotlight;
